import { ZAKAZKA_DRUH } from '@/modules/servis/zakazka/constants';

import { apiProvider } from './api';

export async function createAndSave(state: any, druh = ZAKAZKA_DRUH.ZAPUJCKA, OtevrenePrp: boolean = true) {
	const zakazka = (await apiProvider.zakazkaDefault({ OtevrenePrp, ZakaznikId: state.edit.ZakaznikId, ZakazkaDruh: druh })).data;
	const resp = await apiProvider.zakazkaSave(zakazka);
	return resp.headers.location.split('=')[1];
}
